import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

export const SearchProgress = ({ active, steps, hint, rate = 1, testid = "search-progress" }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!active) {
      setProgress(0);
      return;
    }
    setProgress(6);
    const t = setInterval(() => {
      setProgress((p) => Math.min(95, p + rate * (p < 55 ? 2.4 : p < 80 ? 1.1 : 0.4)));
    }, 1000);
    return () => clearInterval(t);
  }, [active, rate]);

  if (!active) return null;
  const step = steps[Math.min(steps.length - 1, Math.floor((progress / 100) * steps.length))];
  return (
    <div data-testid={testid} className="mt-4 rounded-xl border border-[#E2DCD2] bg-[#FBF9F5] p-4">
      <div className="flex items-center justify-between text-sm font-medium text-[#1B3A4B]">
        <span className="flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin text-[#A6844A]" /> {step}</span>
        <span className="tabular-nums text-[#5C564E]">{Math.round(progress)}%</span>
      </div>
      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-[#ECE5D8]">
        <div className="h-full rounded-full bg-[#A6844A] transition-all duration-700 ease-out" style={{ width: `${progress}%` }} />
      </div>
      {hint && <p className="mt-2 text-xs text-[#5C564E]">{hint}</p>}
    </div>
  );
};
